import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { PaymentReport } from '../../../components/reports/PaymentReport/PaymentReport';

export const PaymentReportPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle">Payment Report</h1>
      <PaymentReport />
    </Layout>
  );
};
